import ColorConstants from '@shared/constants/ColorConstants';

export const segmentsGraphColors = [
    ColorConstants.wisteria,
    ColorConstants.riptide,
    ColorConstants['portage-light-dark'],
    ColorConstants['columbia-blue'],
];
